const KEY = 'f1tips_username';
const EMAIL_KEY = 'f1tips_email';
const FAVOURITE_DRIVER_KEY = 'f1tips_favourite_driver';

export const getStoredUser = () => localStorage.getItem(KEY) || '';
export const setStoredUser = (name) => localStorage.setItem(KEY, name);

export const getStoredEmail = () => localStorage.getItem(EMAIL_KEY) || '';
export const setStoredEmail = (email) => localStorage.setItem(EMAIL_KEY, email);

const raceCodeKey = (raceId) => `f1tips_race_code_${raceId}`;
export const getStoredRaceCode = (raceId) => localStorage.getItem(raceCodeKey(raceId)) || '';
export const setStoredRaceCode = (raceId, code) => localStorage.setItem(raceCodeKey(raceId), code);
export const clearStoredRaceCode = (raceId) => localStorage.removeItem(raceCodeKey(raceId));

const podiumSeenKey = (raceId) => `f1tips_podium_seen_${raceId}`;
export const hasSeenPodium = (raceId) => localStorage.getItem(podiumSeenKey(raceId)) === '1';
export const markPodiumSeen = (raceId) => localStorage.setItem(podiumSeenKey(raceId), '1');

export const getFavouriteDriver = () => localStorage.getItem(FAVOURITE_DRIVER_KEY) || '';
export const setFavouriteDriver = (acronym) => acronym ? localStorage.setItem(FAVOURITE_DRIVER_KEY, acronym) : localStorage.removeItem(FAVOURITE_DRIVER_KEY);
